import CustomizedTooltip from "../../components/CustomizedTooltip"
import IconCheckedSuccess from "../../components/atoms/IconCheckedSuccess"
import Footer from "../../components/main/Footer"
import { Topbar } from "../../components/organisms/Topbar"
import { COUNTRY_CODES } from "../../constants"
import { initPdiComponent } from "../../core/service/BusinessLogicService"
import { loc } from "../../core/utils"
import { dropDelayOrder } from "../../service/OfferService"
import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useQuery } from "react-query"

function AcceptancePage({ tunnelData, history }) {
  const { opl, data, clickAndCollectDocuments, commandAcceptedShopUrl, access_token, apiUrl, isJourneyResumedAtHome } = tunnelData

  const [shopUrlParsed, setShopUrlParsed] = useState(commandAcceptedShopUrl)

  const { data: offerDroppingDelay, isLoading } = useQuery({
    queryKey: ["query-drop-delay-order", opl],
    queryFn: () => dropDelayOrder(apiUrl, opl, access_token),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!opl
  })

  useEffect(() => {
    initPdiComponent("AcceptancePage")

    let shopUrlToParse = commandAcceptedShopUrl
    const langsToReplaceShopURL = [COUNTRY_CODES.FR_BE, COUNTRY_CODES.NL_BE, COUNTRY_CODES.FR_FR]
    const langOfOrder = data?.order?.orderLanguageTag ?? null

    if (commandAcceptedShopUrl && langsToReplaceShopURL.includes(langOfOrder)) setShopUrlParsed(shopUrlToParse.replace("OPL", opl))
    else setShopUrlParsed(commandAcceptedShopUrl)
  }, [offerDroppingDelay, commandAcceptedShopUrl, data, opl])

  if (isLoading) return null

  return (
    <Container fluid>
      <Row noGutters>
        <Col className="misc-block">
          <Row>
            <Topbar tunnelData={tunnelData} displayToggleButton={false} history={history} />

            <Col sm={12}>
              <Container>
                <Row className="justify-content-center">
                  <Col xs={11} sm={10} md={10} lg={6} className="hard-shadow-white-block text-center misc-mono-block">
                    <IconCheckedSuccess />
                    <h1>{loc`Acceptance in principle`}</h1>
                    <h2>{loc("lets_go")}</h2>
                    <p>{loc("you_have_x_days_to", { offerDroppingDelay, shop: data.order.supplierName })}</p>
                    <div className="required-documents">
                      <ul className="list-unstyled text-left">
                        {clickAndCollectDocuments?.map((document, index) => {
                          return (
                            <li key={index}>
                              <CustomizedTooltip document={document} />
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    {!isJourneyResumedAtHome && (
                      <Button href={shopUrlParsed} variant="primary" className="ico-back-small-before">
                        {loc`Back to shop`}
                      </Button>
                    )}
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col sm={12}>
              <Container>
                <Footer tunnelData={tunnelData} />
              </Container>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default AcceptancePage
